/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Notice API Specification
 * OpenAPI spec version: 0.0.8
 */

export type NoticeOverViewEmailRequest =
  (typeof NoticeOverViewEmailRequest)[keyof typeof NoticeOverViewEmailRequest];

export const NoticeOverViewEmailRequest = {
  FAILED: 'FAILED',
  NONE: 'NONE',
  SUCCEEDED: 'SUCCEEDED',
} as const;
